export default "__VITE_ASSET__BSZIe0gm__"